import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_REC015_Request,
  IAPI_REC015_Response,
} from "../../../type/apiType/index";

// 請求・収納一覧参照API
const httpAPI_REC015 = async (
  param: IAPI_REC015_Request
): Promise<IAPI_REC015_Response> => {
  const res = await http.post(ApiUrl.API_REC015, {
    ...param,
  });
  return res.data;
};

export { httpAPI_REC015 };
